export default __webpack_public_path__ + "static/Bitter-Bold-537409ea5ab7adfa1deeca9abadce960.woff2";